// `StatusChip` (design-system spec §3.5) — the 20 px status pill with the 6 px
// dot. Variants map the fixed semantic trio + neutral + accent; the meanings
// are product-wide law: green = confirmed/running/good, amber = attention/
// setup, red = failed/scrap/downtime. status-badge.tsx re-bases onto this.

import type { ReactNode } from "react";

export type ChipVariant = "ok" | "warn" | "bad" | "neutral" | "accent";

export interface StatusChipProps {
  variant: ChipVariant;
  children: ReactNode;
  /** The 6 px dot renders by default; pass false for text-only pills. */
  dot?: boolean;
  className?: string;
  "data-testid"?: string;
  "data-status"?: string;
}

export function StatusChip({ variant, children, dot = true, className, ...rest }: StatusChipProps) {
  const classes = ["ds-chip", `ds-chip-${variant}`];
  if (className !== undefined) classes.push(className);
  return (
    <span className={classes.join(" ")} {...rest}>
      {dot ? <span className="ds-chip-d" aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
